import { render, staticRenderFns } from "./audio-player.vue?vue&type=template&id=7cab2fea&scoped=true&lang=html&"
import script from "./audio-player.vue?vue&type=script&lang=js&"
export * from "./audio-player.vue?vue&type=script&lang=js&"
import style0 from "./audio-player.vue?vue&type=style&index=0&id=7cab2fea&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cab2fea",
  null
  
)

export default component.exports